export default __webpack_public_path__ + "static/media/Copy.c858f7b9.svg";